import { PasswordInput, SingleFilePicker, Validator } from "react-admin-base-bootstrap";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import { Field } from "./Fields";
import { CountrySelect } from "./Selects";

export default function UserInfoInput({ data, setData, required, pwRequired }) {
	return <>
		<Field title="Name & Surname" type="required">
			<Input
				type="text"
				value={data.name || ''}
				onChange={a => setData({name: a.currentTarget.value})}
			/>
		</Field>
		<Field title="E-Mail" type="required|email">
			<Input
				type="text"
				value={data.email || ''}
				onChange={a => setData({email: a.currentTarget.value})}
			/>
		</Field>
		
		<PasswordInput
			value={data.password || ''}
			onChange={a => setData({password: a})}
			required={pwRequired}
			placeholder={!pwRequired ? 'Type if you want to change your password' : ''}
		/>
		
		<Field title="Phone" type={required && "required"}>
			<Input
				type="tel"
				//pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
				value={data.phone || ''}
				onChange={a => setData({phone: a.currentTarget.value})}
			/>
		</Field>
	</>;
}